import React from "react";
import {
  Box,
  Typography,
  useMediaQuery, // Menu, MenuItem, IconButton removed as unused
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg"
import twitter from "../assets/twitter.svg";
import youtube from "../assets/youtube.svg";
import linkedin from "../assets/linkedin.svg";
import footerlogo from "../assets/footerlogo.png";
import footerlogoen from "../assets/footerlogoen.png"
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { BASE_URL } from "../components/BASE_URL";

const hasValue = (value) =>
  value != null && String(value).trim() !== "";

const toExternalUrl = (url) => {
  const trimmed = String(url).trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};

const formatPhoneNumber = (value) => {
  const digits = String(value).replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return value;
};

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t, i18n } = useTranslation();
const [social, setSocial] = useState(null);
const [loadingSocial, setLoadingSocial] = useState(true);
  const productCore = t("footer_product_core", { returnObjects: true });
    const Industry = t("Industries", { returnObjects: true });
  const footer_industries = t("footer_industries", { returnObjects: true });
  const footer_advanced_capabilities = t("footer_advanced_capabilities", {
    returnObjects: true,
  });

  const companySupport = t("footer_company_support", { returnObjects: true });

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
const heroImageSrc = i18n.language === "es" ? footerlogo: footerlogoen;
useEffect(() => {
  async function fetchSocialLinks() {
    const url = `${BASE_URL}social-links`;
    console.log("FOOTER: Fetching social links from:", url);

    try {
      const res = await fetch(url);
      console.log("FOOTER: Social links response status:", res.status, res.statusText);

      const json = await res.json();
      console.log("FOOTER: Social links API response:", json);

      if (!json.error && json.data) {
        console.log("FOOTER: Social links data set:", json.data);
        setSocial(json.data);
      } else {
        console.log("FOOTER: Social links API returned error or no data:", {
          error: json.error,
          data: json.data,
        });
      }
    } catch (err) {
      console.log("FOOTER SOCIAL LINKS ERROR:", err);
    } finally {
      setLoadingSocial(false);
      console.log("FOOTER: Social links fetch complete");
    }
  }

  fetchSocialLinks();
}, []);

  const contactLabelSx = {
    fontSize: "12px",
    color: "rgba(255, 255, 255, 0.75)",
    fontFamily: "Poppins, sans-serif",
    mb: 0.25,
  };

  const contactValueSx = {
    fontSize: "14px",
    color: "#ffffff",
    fontFamily: "Poppins, sans-serif",
    mb: 2,
  };

  const hasSocialLinks =
    hasValue(social?.facebook_link) ||
    hasValue(social?.instagram_link) ||
    hasValue(social?.youtube_link) ||
    hasValue(social?.twitter_link) ||
    hasValue(social?.linkedin_link);

  const androidApps = [
    { key: "accountExecutive", label: t("Account Executive"), link: "https://play.google.com/store/apps/details?id=com.biometricproaccountexecutive1" },
    { key: "companyAdmin", label: t("Company Admin"), link: "https://play.google.com/store/apps/details?id=com.biometricprocompanyadminapp" },
    { key: "employee", label: t("Employee"), link: "https://play.google.com/store/apps/details?id=com.biometricproemployeeapp" },
  ];

  const iosApps = [
    { key: "accountExecutive", label: t("Account Executive"), link: "https://apps.apple.com/us/app/account-executive-biometricpro/id6752927067" },
    { key: "companyAdmin", label: t("Company Admin"), link: "https://apps.apple.com/us/app/company-admin-biometric-pro/id6788851657" },
    { key: "employee", label: t("Employee"), link: "https://apps.apple.com/us/app/employee-biometric-pro/id6790351839" },
  ];

  const appPlatformLabelSx = {
    fontSize: "10px",
    fontWeight: 600,
    color: "rgba(255, 255, 255, 0.55)",
    fontFamily: "Poppins, sans-serif",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    mb: 0.75,
    whiteSpace: "nowrap",
  };

  const appLinkSx = {
    fontSize: "11px",
    color: "rgba(255, 255, 255, 0.85)",
    fontFamily: "Poppins, sans-serif",
    textDecoration: "none",
    display: "block",
    mb: 0.75,
    lineHeight: 1.3,
    overflowWrap: "break-word",
    wordBreak: "break-word",
    transition: "color 0.15s ease",
    "&:hover": { color: "#ffffff", textDecoration: "underline" },
  };

  return (
    <Box
      sx={{
        background:
          "linear-gradient(to left, #003149 0%, #003149 50%,rgb(15, 88, 143) 100%)",
        color: "#FFFFFF",
        px: isMobile ? 4 : 8,
        py: 6,
        width: "100%",
        position: "relative", // Needed for absolute positioning of language switcher
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1440px",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: "wrap",
            justifyContent: { xs: "flex-start", md: "space-between" },
            alignItems: { xs: "flex-start", md: "stretch" },
            rowGap: 1,
          }}
        >
          {/* Column 1 - Logo & Contact */}
          <Box sx={{ flexBasis: { xs: "auto", md: "230px" }, flexGrow: 1, flexShrink: 1, minWidth: "200px" }}>
            <Box sx={{ mb: 3 }}>
              <img
                src={heroImageSrc}
                alt="logo"
                style={{ height: 40, objectFit: "contain" }}
              />
            </Box>

            {!loadingSocial && hasValue(social?.email) && (
              <Box sx={{ mt: 2, mb: 1 }}>
                <Typography sx={contactLabelSx}>
                  {t("footer_official_support_email")}
                </Typography>
                <Typography
                  component="a"
                  href={`mailto:${social.email}`}
                  sx={{
                    ...contactValueSx,
                    textDecoration: "underline",
                    display: "block",
                  }}
                >
                  {social.email}
                </Typography>
              </Box>
            )}

            {!loadingSocial && hasValue(social?.business_phone_no) && (
              <Box sx={{ mb: 1 }}>
                <Typography sx={contactLabelSx}>
                  {t("footer_business_phone_number")}
                </Typography>
                <Typography
                  component="a"
                  href={`tel:${social.business_phone_no}`}
                  sx={{
                    ...contactValueSx,
                    textDecoration: "underline",
                    display: "block",
                  }}
                >
                  {formatPhoneNumber(social.business_phone_no)}
                </Typography>
              </Box>
            )}

            {!loadingSocial && hasValue(social?.company_address) && (
              <Box sx={{ mb: 1 }}>
                <Typography sx={contactLabelSx}>
                  {t("footer_company_address")}
                </Typography>
                <Typography sx={{ ...contactValueSx, mb: 3, lineHeight: 1.5 }}>
                  {social.company_address}
                </Typography>
              </Box>
            )}

            {hasSocialLinks && (
            <Box sx={{ display: "flex", gap: 1.5, mb: 3 }}>
              {hasValue(social?.facebook_link) && (
              <a
                className="footer-image"
                href={toExternalUrl(social.facebook_link)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer", display: "inline-flex" }}
              >
                <img
                  src={facebook}
                  alt="Facebook"
                  style={{ width: "35px", height: "35px" }}
                />
              </a>
              )}
              {hasValue(social?.instagram_link) && (
              <a
                className="footer-image"
                href={toExternalUrl(social.instagram_link)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer", display: "inline-flex" }}
              >
                <img
                  src={instagram}
                  alt="Instagram"
                  style={{ width: "35px", height: "35px" }}
                />
              </a>
              )}
              {hasValue(social?.youtube_link) && (
              <a
                className="footer-image"
                href={toExternalUrl(social.youtube_link)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer", display: "inline-flex" }}
              >
                <img
                  src={youtube}
                  alt="YouTube"
                  style={{ width: "35px", height: "35px" }}
                />
              </a>
              )}
              {hasValue(social?.twitter_link) && (
              <a
                className="footer-image"
                href={toExternalUrl(social.twitter_link)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer", display: "inline-flex" }}
              >
                <img
                  src={twitter}
                  alt="Twitter"
                  style={{ width: "40px", height: "40px" }}
                />
              </a>
              )}
              {hasValue(social?.linkedin_link) && (
              <a
                className="footer-image"
                href={toExternalUrl(social.linkedin_link)}
                target="_blank"
                rel="noopener noreferrer"
                style={{ cursor: "pointer", display: "inline-flex" }}
              >
                <img
                  src={linkedin}
                  alt="LinkedIn"
                  style={{ width: "35px", height: "35px" }}
                />
              </a>
              )}
            </Box>
            )}
          </Box>

          {/* Other Columns */}
          <FooterColumn
            title={t("footer_section_product_core")}
            items={productCore}
          />
<FooterColumn
  title={t("footer_section_industries")}
  items={Industry}
/>
          {/* <FooterColumn
            title={t("footer_section_advanced_capabilities")}
            items={footer_advanced_capabilities}
          />
          <FooterColumn
            title={t("footer_section_industries")}
            items={footer_industries}
          /> */}

          <FooterColumn
            title={t("footer_section_company_support")}
            items={companySupport}
          />

          {/* Get the App Column */}
          <Box sx={{ flexBasis: { xs: "auto", md: "200px" }, flexGrow: 1, flexShrink: 1, minWidth: "180px", maxWidth: { xs: "100%", md: "240px" } }}>
            <Typography
              sx={{
                fontWeight: 600,
                mb: 2,
                color: "#ffffff",
                fontSize: "16px",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {t("footer_get_the_app")}
            </Typography>
            <Box sx={{ display: "flex", gap: 1.5 }}>
              <Box sx={{ flex: "1 1 0", minWidth: 0 }}>
                <Typography sx={appPlatformLabelSx}>{t("Android")}</Typography>
                {androidApps.map((app) => (
                  <Typography
                    key={app.key}
                    component="a"
                    href={app.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={appLinkSx}
                  >
                    {app.label}
                  </Typography>
                ))}
              </Box>
              <Box sx={{ flex: "1 1 0", minWidth: 0 }}>
                <Typography sx={appPlatformLabelSx}>{t("iOS")}</Typography>
                {iosApps.map((app) => (
                  <Typography
                    key={app.key}
                    component="a"
                    href={app.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={appLinkSx}
                  >
                    {app.label}
                  </Typography>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

    </Box>
  );
};

const FooterColumn = ({ title, items }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleItemClick = (itemText) => {
    const lowerItemText =
      typeof itemText === "string" ? itemText.toLowerCase().trim() : "";
    if (lowerItemText === "about" || lowerItemText === "acerca de") {
      navigate("/about");
    } else if (lowerItemText === "contact" || lowerItemText === "contacto") {
      navigate("/contact");
    } 
     else if (
    lowerItemText === "mobile app" ||
    lowerItemText === "aplicación móvil"
  ) {
    navigate("/mobile-app"); // 👈 Add this line
  }else if (
      lowerItemText === "privacy policy" ||
      lowerItemText === "política de privacidad"
    ) {
      navigate("/privacy");
    } 
    else if (
      lowerItemText === "time tracking" ||
  lowerItemText === "seguimiento de tiempo"
    ) {
       navigate("/time-tracking")
    } 

     else if (
      lowerItemText === "task management" ||
  lowerItemText === "gestión de tareas"
    ) {
       navigate("/task-management")
    } 
         else if (
      lowerItemText === "clock in and out with precision" ||
  lowerItemText === "registrar la entrada y salida con precisión"
    ) {
     navigate("/time-tracking#card1-attendence");
    } 
             else if (
      lowerItemText === "calendar view" ||
  lowerItemText === "vista de calendario"
    ) {
     navigate("/task-management#task-map-calendar-integration");
    } 
                 else if (
      lowerItemText === "subscription & billing" ||
  lowerItemText === "suscripción y facturación"
    ) {
     navigate("/financial#finance-payment-history");
    } 
 else if (
  lowerItemText === "accessibility" ||
  lowerItemText === "accesibilidad"
) {
  navigate("/accessibility");
}
    else if (
      lowerItemText === "terms of service" ||
      lowerItemText === "términos del servicio"
    ) {
      navigate("/terms");
    } else if (
      lowerItemText === "Time Tracking" ||
      lowerItemText === "Seguimiento de tiempo"
    ) {
      navigate("/time-tracking");
    }

  
else if (
  lowerItemText === "view all industries" ||
  lowerItemText === "ver todas las industrias"
) {
  if (location.pathname === "/view-all-industries") {
    window.history.replaceState(null, null, "/view-all-industries");
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    navigate("/view-all-industries");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

else if (
  lowerItemText === "field workers" ||
  lowerItemText === "field employees" ||
  lowerItemText === "trabajadores de campo" ||
  lowerItemText === "empleados de campo"
) {
  navigate("/view-all-industries#workers");
}

else if (
  lowerItemText === "office workers" ||
  lowerItemText === "office employees" ||
  lowerItemText === "trabajadores de oficina" ||
  lowerItemText === "empleados de oficina"
) {
  navigate("/view-all-industries#office-workers");
}

else if (
  lowerItemText === "on-site workers" ||
  lowerItemText === "on-site employees" ||
  lowerItemText === "trabajadores presenciales" ||
  lowerItemText === "empleados presenciales"
) {
  navigate("/view-all-industries#onsite-workers");
}
 

  };


  return (
    <Box sx={{ flexBasis: { xs: "auto", md: "180px" }, flexGrow: 1, flexShrink: 1, minWidth: "160px" }}>
      <Typography
        sx={{
          fontWeight: 600,
          mb: 2,
          color: "#ffffff",
          fontSize: "16px",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        {title}
      </Typography>
      {items.map((item) => (
        <Typography
          key={item}
          onClick={() => handleItemClick(item)}
          sx={{
            fontSize: "14px",
            color: "#FFFCFC",
            mb: 1.7,
            fontFamily: "Nunito, sans-serif",
            fontWeight: 500,
            cursor: "pointer",

          }}
        >
          {item}
        </Typography>
      ))}
    </Box>
  );
};

export default Footer;
